<template>
  <el-container class="page">
    <AppSidebar :active-menu.sync="activeMenu" />

    <el-container>
      <el-header class="header">
        <div class="header-left">
          <i class="el-icon-s-grid"></i>
          <span class="header-title">财务汇算</span>
        </div>

        <div class="header-right">
          <!-- 导入功能已移除 -->
        </div>
      </el-header>

      <el-main class="main">
        <!-- 二级工具栏（贴近截图） -->
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-download" @click="onExport">导出数据</el-button>
          <el-button type="warning" icon="el-icon-edit" @click="onBatchEditPrice">批量修改价格</el-button>
          <el-button icon="el-icon-user" @click="onBatchEditTalent">批量修改达人</el-button>
          <el-button type="success" icon="el-icon-refresh" @click="onRefresh">刷新数据</el-button>
        </div>

        <!-- 筛选区 -->
        <el-card shadow="never" class="filter-card">
          <el-form :inline="true" size="small" class="filter-form">
            <el-form-item label="平台筛选：">
              <el-select v-model="filters.platform" placeholder="全部游客" style="width: 140px">
                <el-option label="全部游客" value="" />
                <el-option v-for="(p, idx) in platformOptions" :key="idx" :label="p" :value="p" />
              </el-select>
            </el-form-item>

            <el-form-item label="票种类型：">
              <el-select v-model="filters.ticketType" placeholder="全部类型" style="width: 140px">
                <el-option label="全部类型" value="" />
                <el-option v-for="(t, idx) in ticketTypeOptions" :key="idx" :label="t" :value="t" />
              </el-select>
            </el-form-item>

            <el-form-item label="供应商：">
              <el-select v-model="filters.supplier" placeholder="全部供应商" style="width: 160px">
                <el-option label="全部供应商" value="" />
                <el-option v-for="(s, idx) in supplierOptions" :key="idx" :label="s" :value="s" />
              </el-select>
            </el-form-item>

            <el-form-item label="游玩区域：">
              <el-select v-model="filters.area" placeholder="全部区域" style="width: 140px">
                <el-option label="全部区域" value="" />
                <el-option v-for="(a, idx) in areaOptions" :key="idx" :label="a" :value="a" />
              </el-select>
            </el-form-item>

            <el-form-item label="入园日期：">
              <!-- 入园日期改为下拉菜单，选项来源于系统设置中的 visitDates -->
              <el-select
                v-model="filters.visitDate"
                placeholder="选择入园日期"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(d, idx) in historyDates.filter(isFutureDate)"
                  :key="'visit-' + idx"
                  :label="formatHistoryLabel(d)"
                  :value="d"
                />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button class="clear-date-btn" @click="clearDate">清空日期</el-button>
            </el-form-item>

            <el-form-item label="达人筛选：">
              <el-select v-model="filters.talent" placeholder="全部达人" style="width: 140px">
                <el-option label="全部达人" value="" />
                <el-option label="达人1" value="达人1" />
                <el-option label="达人2" value="达人2" />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="applyFilters">应用筛选</el-button>
              <el-button @click="resetFilters">清除筛选</el-button>
            </el-form-item>
            <el-form-item label="历史查询：">
              <!-- 历史查询改为下拉菜单，选项来源于系统设置中的 visitDates -->
              <el-select
                v-model="historyDate"
                placeholder="选择历史日期"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(d, idx) in historyDates"
                  :key="'history-' + idx"
                  :label="formatHistoryLabel(d)"
                  :value="d"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="applyHistory">历史查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 表格区 -->
        <el-card shadow="never" class="table-card">
          <el-table
            :data="filteredData"
            stripe
            border
            height="70vh"
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#303133', fontWeight: 700 }"
            :cell-style="{ padding: '10px 0' }"
            empty-text=""
            @selection-change="onSelectionChange"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column label="编号" type="index" width="60" />
            <el-table-column prop="orderNo" label="订单号" min-width="120" show-overflow-tooltip />
            <el-table-column prop="name" label="游客姓名" min-width="110" />
            <el-table-column prop="visitDate" label="入园日期" min-width="110" />
            <el-table-column prop="platform" label="观礼平台" min-width="110" />
            <el-table-column prop="ticketType" label="票种类型" min-width="100" />
            <el-table-column prop="area" label="游玩区域" min-width="100" />
            <el-table-column prop="supplier" label="供应商" min-width="100" />

            <el-table-column prop="retailPrice" label="零售价" min-width="100" />
            <el-table-column prop="settlementPrice" label="结算价" min-width="100" />
            <el-table-column prop="talent" label="达人名称" min-width="110" />
            <el-table-column prop="commissionRate" label="提成比例" min-width="100" />
            <el-table-column prop="commissionAmount" label="提成金额" min-width="100" />
            <el-table-column prop="profit" label="利润" min-width="90" />
            <el-table-column prop="profitRate" label="利润率" min-width="90" />

            <el-table-column label="操作" width="140" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onEdit(scope.row)">编辑</el-button>

              </template>
            </el-table-column>
          </el-table>

          <div v-if="filteredData.length === 0" class="empty">
            <div class="empty-icon">
              <i class="el-icon-coin"></i>
            </div>
            <div class="empty-title">暂无游客数据</div>
            <div class="empty-sub">请前往“游客信息录入”页面添加数据，或使用“导入数据”功能导入历史数据</div>
          </div>

          <div class="pager">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :current-page="page"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100, 200, 500]"
              @size-change="onPageSizeChange"
              @current-change="onPageChange"
            />
          </div>
        </el-card>
      </el-main>
    </el-container>

    <!-- 批量修改价格弹窗 -->
    <el-dialog title="批量修改价格" :visible.sync="batchPriceDialogVisible" width="520px">
      <el-form label-width="100px">
        <el-form-item label="零售价">
          <el-input v-model="batchPriceForm.retailPrice" placeholder="例如：120" />
        </el-form-item>
        <el-form-item label="结算价">
          <el-input v-model="batchPriceForm.settlementPrice" placeholder="例如：100" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchPriceDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onConfirmBatchEditPrice">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹窗（示例） -->
    <el-dialog title="编辑财务信息" :visible.sync="editDialogVisible" width="520px">
      <el-form label-width="100px">
        <el-form-item label="零售价">
          <el-input v-model="editForm.retailPrice" />
        </el-form-item>
        <el-form-item label="结算价">
          <el-input v-model="editForm.settlementPrice" />
        </el-form-item>
        <el-form-item label="达人名称">
          <el-input v-model="editForm.talent" />
        </el-form-item>
        <el-form-item label="提成比例">
          <el-input v-model="editForm.commissionRate" placeholder="例如：10%" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSaveEdit">保存</el-button>
      </span>
    </el-dialog>
    
    <!-- 导入记录弹窗 -->
    <el-dialog title="导入记录" :visible.sync="importsDialogVisible" width="90%">
      <el-table :data="importsList" v-loading="importsLoading" style="width: 100%" size="small">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="orderNo" label="订单号" width="120" />
        <el-table-column prop="customerName" label="游客姓名" width="140" />
        <el-table-column prop="idNo" label="证件号" width="160" />
        <el-table-column prop="visitDate" label="入园日期" width="120" />
        <el-table-column prop="platform" label="观礼平台" width="100" />
        <el-table-column prop="ticketType" label="票种类型" width="100" />
        <el-table-column prop="retailPrice" label="零售价" width="100" />
        <el-table-column prop="settlementPrice" label="结算价" width="100" />
        <el-table-column prop="commissionRate" label="提成比例" width="100" />
        <el-table-column prop="talent" label="达人" width="120" />
        <el-table-column prop="importedAt" label="导入时间" width="160" />
      </el-table>
      <div style="text-align: right; margin-top: 12px;">
        <el-pagination
          background
          :page-size="importsPageSize"
          :current-page.sync="importsPage"
          :total="importsTotal"
          layout="prev, pager, next, jumper"
          @current-change="onImportsPageChange"
        />
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import AppSidebar from '../../components/AppSidebar.vue'
import { getFinance, updateFinance, batchUpdateFinancePrice, batchUpdateFinanceTalent, getSettings, getAdmins } from '../../api'
import { API_BASE } from '../../api/http'
import { buildQuery, downloadByUrl } from '../../utils/download'
import { PLATFORMS, PLATFORM_AREAS } from '../../config/platforms'


export default {
  name: 'FinancePage',
  components: { AppSidebar },
  data() {
    return {
      activeMenu: '4',
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: {
        platform: '',
        ticketType: '',
        area: '',
        visitDate: '',
        supplier: '',
        talent: ''
      },
      // options from settings
      platformOptions: [],
      ticketTypeOptions: [],
      areaOptions: [],
      supplierOptions: [],
      editDialogVisible: false,
      editRowRef: null,
      selectedRows: [],
      batchPriceDialogVisible: false,
      batchPriceForm: {
        retailPrice: '',
        settlementPrice: ''
      },
      editForm: {
        retailPrice: '',
        settlementPrice: '',
        talent: '',
        commissionRate: ''
      }
      ,historyDate: '',
      historyDates: [],
    }
  },
  computed: {
    filteredData() {
      // 后端已支持筛选并计算字段，这里直接展示 tableData
      return this.tableData
    }
  },
  created() {
    this.loadData()
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const data = await getSettings()
        const visitor = (data && data.visitor) || {}
        this.historyDates = visitor.visitDates || []
        if (this.historyDates.length > 0 && !this.historyDate) this.historyDate = this.historyDates[0]

        // 平台使用前端固定平台
        this.platformOptions = PLATFORMS.slice()

        // ticket type options
        this.ticketTypeOptions = Array.isArray(visitor.ticketTypeOptions) ? visitor.ticketTypeOptions : (visitor.ticketTypeOptions || [])

        // 游玩区域使用前端固定 PLATFORM_AREAS（不再使用后端 areaOptions）
        this.areaOptions = Object.keys(PLATFORM_AREAS).reduce((acc, p) => acc.concat(PLATFORM_AREAS[p] || []), [])
        this.areaOptions = Array.from(new Set(this.areaOptions))
        // 供应商选项：先从系统设置读取，再尝试合并管理员账号里的 supplier 字段（以保证来源完整）
        const serverSuppliers = Array.isArray(visitor.supplierOptions) ? visitor.supplierOptions : (visitor.supplierOptions || [])
        let adminSuppliers = []
        try {
          const adminsResp = await getAdmins()
          const admins = adminsResp && Array.isArray(adminsResp.list) ? adminsResp.list : []
          adminSuppliers = Array.from(new Set(admins.map(a => (a && a.supplier) ? String(a.supplier).trim() : '').filter(Boolean)))
        } catch (e) {
          adminSuppliers = []
        }
        this.supplierOptions = Array.from(new Set([...(serverSuppliers || []), ...adminSuppliers]))
      } catch (e) {
        this.historyDates = []
        this.platformOptions = []
        this.ticketTypeOptions = []
        this.areaOptions = []
        this.supplierOptions = []
      }
    },
    disabledHistoryDate(date) {
      if (!date) return true
      try {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        const s = `${y}/${m}/${d}`
        return !(this.historyDates || []).includes(s)
      } catch (e) {
        return true
      }
    },
    formatHistoryLabel(d) {
      try {
        const s = String(d).replace(/\//g, '-')
        const dt = new Date(s)
        if (isNaN(dt.getTime())) return d
        const y = dt.getFullYear()
        const m = String(dt.getMonth() + 1).padStart(2, '0')
        const day = String(dt.getDate()).padStart(2, '0')
        return `${y}.${m}.${day}`
      } catch (e) {
        return d
      }
    },
    isFutureDate(d) {
      // 判断日期是否为当前日期及以后
      try {
        const s = String(d).replace(/\//g, '-')
        const dt = new Date(s)
        if (isNaN(dt.getTime())) return false
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        dt.setHours(0, 0, 0, 0)
        return dt >= today
      } catch (e) {
        return false
      }
    },
    applyHistory() {
      if (!this.historyDate) {
        this.$message.warning('请先选择历史日期')
        return
      }
      this.filters.visitDate = this.historyDate
      this.page = 1
      this.loadData()
    },
    onSelectionChange(rows) {
      this.selectedRows = rows || []
    },
    onPageChange(p) {
      this.page = p
      this.loadData()
    },
    onPageSizeChange(ps) {
      this.pageSize = ps
      this.page = 1
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        // Prepare params and normalize ticketType to mitigate backend/client value differences
        const params = {
          ...this.filters,
          page: this.page,
          pageSize: this.pageSize
        }
        if (params.ticketType) {
          // send the user-visible ticket type as-is (keep trailing "票" if present)
          params.ticketType = String(params.ticketType).trim().replace(/\s+/g, ' ')
        }

        const data = await getFinance(params)
        this.tableData = data.list || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    clearDate() {
      this.filters.visitDate = ''
    },
    async applyFilters() {
      this.page = 1
      await this.loadData()
      this.$message.success('已应用筛选')
    },
    async resetFilters() {
      this.filters = { platform: '', ticketType: '', area: '', visitDate: '', talent: '' }
      this.page = 1
      await this.loadData()
    },
    // 导入功能已移除
    onExport() {
      // 复用项目里“游客信息表/核销表”的导出方式：拼接 URL 后直接下载
      const exportFilters = Object.assign({}, this.filters)
      if (exportFilters.ticketType) {
        // keep original display value (including trailing "票")
        exportFilters.ticketType = String(exportFilters.ticketType).trim().replace(/\s+/g, ' ')
      }
      const url = `${API_BASE}/api/export/finance.csv${buildQuery(exportFilters)}`
      downloadByUrl(url)
    },
    onExportPhone() {
      this.$message.info('仅导出手机号（待实现）')
    },
    onBatchEditPrice() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先勾选需要修改的记录')
        return
      }
      // 打开弹窗：一次输入两个价格
      this.batchPriceForm = { retailPrice: '', settlementPrice: '' }
      this.batchPriceDialogVisible = true
    },
    async onConfirmBatchEditPrice() {
      const retail = String(this.batchPriceForm.retailPrice ?? '').trim()
      const settle = String(this.batchPriceForm.settlementPrice ?? '').trim()

      if (retail === '' || settle === '') {
        this.$message.warning('请填写零售价和结算价')
        return
      }
      if (!/^\d+(\.\d+)?$/.test(retail) || !/^\d+(\.\d+)?$/.test(settle)) {
        this.$message.warning('零售价/结算价必须为数字')
        return
      }

      try {
        const ids = this.selectedRows.map(r => r.visitorId).filter(Boolean)
        const res = await batchUpdateFinancePrice({ retailPrice: retail, settlementPrice: settle, ids }, {})
        this.batchPriceDialogVisible = false
        await this.loadData()
        this.$message.success(`已批量更新 ${res.updated || 0} 条`)
      } catch (e) {
        this.$message.error(e.message || '批量更新失败')
      }
    },
    async onBatchEditTalent() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先勾选需要修改的记录')
        return
      }

      // 使用自定义弹窗，一次输入“达人名称 + 提成比例”
      const h = this.$createElement
      const form = { talent: '', commissionRate: '' }

      this.$msgbox({
        title: '批量修改达人',
        message: h('div', { style: { paddingTop: '6px' } }, [
          h('div', { style: { marginBottom: '10px', color: '#606266', fontSize: '12px' } }, '请输入要批量设置的内容（达人名称可选，提成比例可选）'),
          h('div', { style: { marginBottom: '10px' } }, [
            h('div', { style: { marginBottom: '6px', fontSize: '12px', color: '#303133' } }, ['达人名称']),
            h('input', {
              domProps: { value: form.talent },
              attrs: { placeholder: '例如：达人A' },
              style: 'width: 100%; box-sizing: border-box; height: 32px; padding: 0 10px; border: 1px solid #dcdfe6; border-radius: 4px;'
            })
          ]),
          h('div', { style: { marginBottom: '4px' } }, [
            h('div', { style: { marginBottom: '6px', fontSize: '12px', color: '#303133' } }, '提成比例(%)'),
            h('input', {
              domProps: { value: form.commissionRate },
              attrs: { placeholder: '例如：10' },
              style: 'width: 100%; box-sizing: border-box; height: 32px; padding: 0 10px; border: 1px solid #dcdfe6; border-radius: 4px;'
            })
          ])
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          // 从 DOM 里取值（element 的 msgbox 用原生 input 更简单）
          try {
            const inputs = instance.$el.querySelectorAll('input')
            form.talent = inputs[0] ? inputs[0].value.trim() : ''
            form.commissionRate = inputs[1] ? inputs[1].value.trim() : ''
          } catch (e) {
            // ignore
          }

          if (action === 'confirm') {
            // talent 非必填；若 commissionRate 存在则需为数字
            if (form.commissionRate !== '' && !/^\d+(\.\d+)?$/.test(form.commissionRate)) {
              this.$message.warning('提成比例必须为数字')
              return
            }
          }
          done()
        }
      })
            .then(async () => {
          try {
            const ids = this.selectedRows.map(r => r.visitorId).filter(Boolean)
            const payload = { ids }
            if (form.talent !== '') payload.talent = form.talent
            if (form.commissionRate !== '') payload.commissionRate = form.commissionRate

            const res = await batchUpdateFinanceTalent(payload, {})
            await this.loadData()
            this.$message.success(`已批量更新 ${res.updated || 0} 条`)
          } catch (e) {
            this.$message.error(e.message || '批量更新失败')
          }
        })
        .catch(() => {})
    },
    async onRefresh() {
      await this.loadData()
      this.$message.success('已刷新')
    },
    onEdit(row) {
      this.editRowRef = row
      this.editForm = {
        retailPrice: row.retailPrice ?? '',
        settlementPrice: row.settlementPrice ?? '',
        talent: row.talent ?? '',
        commissionRate: row.commissionRate ?? ''
      }
      this.editDialogVisible = true
    },
    async onSaveEdit() {
      if (!this.editRowRef) return
      try {
        await updateFinance(this.editRowRef.visitorId, {
          retailPrice: this.editForm.retailPrice,
          settlementPrice: this.editForm.settlementPrice,
          commissionRate: this.editForm.commissionRate,
          talent: this.editForm.talent
        })
        this.editDialogVisible = false
        await this.loadData()
        this.$message.success('已保存')
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      }
    },
  }
}
</script>

<style scoped>
.page {
  height: 100vh;
  background: #f5f7fa;
}

.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #303133;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
}

.main {
  padding: 16px;
}

.toolbar {
  display: flex;
  gap: 10px;
  padding: 0 0 12px;
}

.filter-card {
  margin-bottom: 16px;
}

.filter-form ::v-deep .el-form-item {
  margin-right: 16px;
  margin-bottom: 10px;
}

.clear-date-btn {
  width: 72px;
  height: 32px;
  padding: 0 10px;
  line-height: 32px;
  border-radius: 4px;
  border: none;
  color: #fff;
  background: #606266;
  white-space: nowrap;
}

.clear-date-btn:hover {
  background: #4e5258;
}

.table-card {
  position: relative;
}

.pager {
  padding: 12px 0 4px;
  display: flex;
  justify-content: flex-end;
}

.danger-text {
  color: #f56c6c;
}

.empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-10%);
  text-align: center;
  color: #909399;
}

.empty-icon {
  font-size: 56px;
  color: #dcdfe6;
}

.empty-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
}

.empty-sub {
  margin-top: 6px;
  font-size: 12px;
}
</style>

